module.exports = __webpack_public_path__ + "img/xingtu-bg.2e4c8ca1.png";